import { apiClient } from "../../../api/client";
import { ApiResponse } from "../../../types";
import { OpsMetricsResult } from "../types";

export interface OpsMetricsParams {
  /** Mês fechado no formato YYYY-MM. Omitido, o backend usa o mais recente. */
  mes?: string;
}

export const metricsService = {
  async opsMetrics(params: OpsMetricsParams): Promise<ApiResponse<OpsMetricsResult>> {
    return apiClient.post("/gestorMetricasOps", params);
  },
};
